import { render, staticRenderFns } from "./PUList.vue?vue&type=template&id=11425d1b&scoped=true"
import script from "./PUList.vue?vue&type=script&lang=js"
export * from "./PUList.vue?vue&type=script&lang=js"
import style0 from "./PUList.vue?vue&type=style&index=0&id=11425d1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11425d1b",
  null
  
)

export default component.exports